module.exports = __webpack_public_path__ + "img/UsedCouponMark.e03bd04b.png";